<script setup lang="ts">
import type { Page, PageGroup, Section } from '@/models'
import { ref, toRefs, type PropType, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import useStrapiStore from '@/composition/strapiStore'
import OpenClose from '@/components/OpenClose.vue'
import PageView from '@/views/PageView.vue'

const messages = {}

const { t } = useI18n({ messages })
const strapiStore = useStrapiStore()

const props = defineProps({
  section: {
    type: Object as PropType<Section>,
    default: () => {},
  },
})
const propRefs = toRefs(props)
// Create a local (typecast) reference to the data
const pageGroup = propRefs.section.value as PageGroup
const pages: Ref<Page[]> = ref([])

const open = ref(false)

async function collatePages() {
  for (const page of pageGroup.pages) {
    const name = page.name?.toString().toLowerCase()
    if (name) {
      const p = await strapiStore.actions.loadPage(name)
      if (p && p.id !== strapiStore.getters.currentPage.value?.id) pages.value.push(p)
    }
  }
}
collatePages()
</script>

<template>
  <div class="border-2 border-solid border-red-400">
    <span>{{ t('open') }}</span>
    <h1>{{ pageGroup.details.title ?? '' }}</h1>
    <p>{{ pageGroup.details.description ?? '' }}</p>
    <button @click="open = !open">Read More</button>
    <OpenClose v-for="page in pages" :key="page.id" :open="open">
      <PageView :page="page" />
    </OpenClose>
  </div>
</template>
